import type { SVGProps } from "react";
export function ArrowLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m7.0202 2.97982c.19526.19526.19526.51185 0 .70711l-3.8131 3.81311h10.7929c.2761 0 .5.22387.5.5s-.2239.5-.5.5h-10.7929l3.8131 3.81316c.19526.1952.19526.5118 0 .707-.19527.1953-.51183.1953-.70709 0l-4.66667-4.66663c-.19526-.19526-.19526-.5118 0-.70706l4.66667-4.66669c.19526-.19526.51182-.19526.70709 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
